// extracted by mini-css-extract-plugin
module.exports = {"container":"logo_container__33mD5","icon":"logo_icon__1PFqu","blue":"logo_blue__29jPm"};